import axios from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';

import { appConfig } from '@config';
import { getRefreshToken, setUser, getUser } from '@helpers/user';

import addAuth from '../addAuth';
import redirectToLogin from '../redirectToLogin';

const axiosInstance = axios.create({});

// Use interceptor to inject the JWT token into requests
axiosInstance.interceptors.request.use(addAuth);

/**
 * Requests a new access token and updates the user
 * If there is no refresh token the user will be redirected to login
 * If the refresh token request fails, the user will be redirected to login
 * @param {AxiosRequest} failedRequest The API request that returned a 401
 * @returns {Promise} Resolves if successful, otherwise rejects
 */
export const refreshAuth = failedRequest => {
  const refreshToken = getRefreshToken();

  if (refreshToken) {
    return axiosInstance
      .post(
        `${appConfig.apiUrl}/auth/token/refresh/`,
        { refresh: refreshToken },
        { skipAuthRefresh: true, noAuth: true }
      )
      .then(tokenRefreshResponse => {
        const token = tokenRefreshResponse.data.access;
        const { userId, refresh } = getUser();
        setUser({ token, id: userId, refresh });
        failedRequest.response.config.headers.Authorization = `JWT ${token}`;
        return Promise.resolve();
      })
      .catch(error => {
        redirectToLogin();
        return Promise.reject(error);
      });
  }

  redirectToLogin();
  return Promise.reject(new Error('No refresh token'));
};

createAuthRefreshInterceptor(axiosInstance, refreshAuth);

export default axiosInstance;
